import { Injectable } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/services/api.service";
import {
  GlobalDataInterface,
  GlobalDataService,
} from "src/app/services/global-data.service";
import { environment } from "src/environments/environment";
import { TransferState, makeStateKey } from "@angular/platform-browser";

const HOME_KEY = makeStateKey("home");

@Injectable({
  providedIn: "root",
})
export class HomeDataService implements Resolve<any> {
  pageData: any;
  initialMallData: GlobalDataInterface;

  constructor(
    private API: ApiService,
    private router: Router,
    private globalData: GlobalDataService,
    private state: TransferState
  ) {
    this.initialMallData = this.globalData.getGlobalData();
  }

  resolve() {
    this.pageData = this.state.get(HOME_KEY, null as any);

    if (!this.pageData) {
      return this.API.GET(
        `public/pages/${environment.mall_id}/${
          this.initialMallData?.defaultPages?.pagesHome || "home"
        }`
      ).pipe(
        catchError((error) => {
          this.router.navigate(["/"]);
          return of(null);
        })
      );
    }
  }
}
